// extracted by mini-css-extract-plugin
module.exports = {"quickBindCard":"index-module_quickBindCard_3vyah","title":"index-module_title_3CZ2W"};